import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import overlayStyles from './OverlayHelpers.scss';
var HoverOnly = React.forwardRef(function (_a, ref) {
    var collapseWhenHidden = _a.collapseWhenHidden, reverseHidden = _a.reverseHidden, children = _a.children, className = _a.className, props = __rest(_a, ["collapseWhenHidden", "reverseHidden", "children", "className"]);
    return (React.createElement("div", __assign({ ref: ref, className: classnames(overlayStyles["hover-".concat(reverseHidden ? 'hidden' : 'only').concat(collapseWhenHidden ? '-and-collapsed' : '')], className) }, props), children));
});
HoverOnly.displayName = 'HoverOnly';
export default HoverOnly;
//# sourceMappingURL=HoverOnly.js.map